module.exports = "/assets/992fa7042d2f0ff578de792df3803c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/V7.png
// module id = 1916
// module chunks = 0